module.exports = __webpack_public_path__ + "img/trousers.183b51dc.png";